<template>
		<div class="home-page">
    <div class="header-bgfff bgfff">
      <Header></Header>
      <div class="nav ac">
        <div class="back" @click="back">
          <img width="80" src="../../static/images/back2.png" />
        </div>
        <div class="nav-t"><span>{{$t('books')}}</span></div>
      </div>
    </div>
			<div class="home-content crfff" ref="scrollContainer" @scroll="handleScroll">
        <!-- Category filter -->
        <div class="category-bar" v-if="categories && categories.length">
          <div class="category-inner">
            <div class="category-select-wrap" ref="categorySelectWrap">
              <div class="category-trigger" @click="toggleCategoryDropdown">
                <span class="category-trigger-text">{{ selectedCategoryName }}</span>
                <span class="category-trigger-arrow" :class="{ 'is-open': categoryDropdownOpen }"></span>
              </div>
              <div v-if="categoryDropdownOpen" class="category-dropdown" role="listbox">
                <div
                  v-for="c in categories"
                  :key="c.id"
                  class="category-option"
                  :class="{ 'is-active': c.id === selectedCategoryId }"
                  @click="selectCategory(c.id)"
                  role="option"
                  :aria-selected="c.id === selectedCategoryId"
                >
                  {{ c.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="book">
          <div class="book-list">
            <div class="book-item" v-for="item in book" :key="item.id" @click="goBook(item.id)">
              <img :src="item.image" class="book-img" />
              <div class="book-name">{{ item.name }}</div>
            </div>
          </div>
          <!-- 加载更多提示 -->
          <div class="load-more-tip" v-if="loading">
            <div class="loading-text">{{$t('loading') || 'loading...'}}</div>
          </div>
          <div class="load-more-tip" v-if="!hasMore && book.length > 0">
            <div class="load-end-text">{{$t('loadMore2') || 'no more books'}}</div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
        categories: [{ id: 0, name: '' }],
        selectedCategoryId: 0,
        categoryDropdownOpen: false,
        book:[],
        page: 1, // 当前页码
        limit: 12, // 每页数量
        hasMore: true, // 是否还有更多数据
        loading: false, // 是否正在加载
        total: 0 // 总数据量
      }
    },
	created(){
    this.get_categories();
	},
  mounted() {
    document.addEventListener('click', this.onDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
  },
  computed: {
    selectedCategoryName() {
      if (this.selectedCategoryId === 0) return this.$t('all_categories');
      const found = (this.categories || []).find(c => c.id === this.selectedCategoryId);
      return found ? found.name : this.$t('all_categories');
    }
  },
  methods: {
		back(){
      this.$router.go(-1);
		},
    get_categories() {
      let that = this;
      that.$api.post('/api/book/categories', {}, r => {
        that.$parent.returnCode(r, function(){
          const list = (r.data && r.data.list) ? r.data.list : [];
          // Insert 'All Categories' (i18n)
          that.categories = [{ id: 0, name: that.$t('all_categories') }].concat(list);
          that.selectedCategoryId = 0;
          that.categoryDropdownOpen = false;
          // 分类就绪后再拉取列表
          that.get_book(false);
        });
      }, () => {
        // 分类请求失败也不影响页面显示
        that.get_book(false);
      });
    },
    toggleCategoryDropdown() {
      this.categoryDropdownOpen = !this.categoryDropdownOpen;
    },
    onDocumentClick(e) {
      // 点击下拉以外区域就关闭
      const wrap = this.$refs.categorySelectWrap;
      if (!wrap) return;
      if (!wrap.contains(e.target)) {
        this.categoryDropdownOpen = false;
      }
    },
    selectCategory(categoryId) {
      this.selectedCategoryId = categoryId;
      this.categoryDropdownOpen = false;
      this.onCategoryChange();
    },
    onCategoryChange() {
      let that = this;
      // 切换分类时重置分页并滚动回顶部
      that.page = 1;
      that.hasMore = true;
      that.book = [];
      that.$nextTick(() => {
        const container = that.$refs.scrollContainer;
        if (container) container.scrollTop = 0;
      });
      that.get_book(false);
    },

    get_book(isLoadMore = false) {
      let that = this;

      // 如果正在加载或没有更多数据，则不请求
      if (that.loading || (!isLoadMore && !that.hasMore)) {
        return;
      }

      that.loading = true;

      // 首次加载显示loading，加载更多不显示
      if (!isLoadMore) {
        that.$parent.loadModal(true);
      }

      that.$api.post('/api/book/list', {
        page: that.page,
        limit: that.limit,
        category_id: that.selectedCategoryId
      }, r => {
        that.$parent.returnCode(r, function(){
          that.$parent.loadModal(false);

          if (isLoadMore) {
            // 加载更多：追加数据
            that.book = that.book.concat(r.data.list || []);
          } else {
            // 首次加载：替换数据
            that.book = r.data.list || [];
          }

          // 更新分页信息
          that.total = r.data.total || 0;
          that.hasMore = r.data.has_more !== false;

          that.loading = false;
        });
      }, () => {
        // 请求失败
        that.loading = false;
        that.$parent.loadModal(false);
      });
    },

    // 滚动事件处理
    handleScroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      // 计算是否滚动到底部（距离底部50px时触发）
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;

      if (scrollHeight - scrollTop - clientHeight < 50) {
        // 滚动到底部，加载更多
        if (this.hasMore && !this.loading) {
          this.page++;
          this.get_book(true);
        }
      }
    },

    goBook(id) {
      this.$router.push({ path: '/BookDetail?id=' + id })
    },
	}
}
</script>
<style>
/* book样式 */
.category-bar{
  position: sticky;
  top: 0;
  z-index: 50;
  padding: 10px 12px;
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border-bottom: 1px solid rgba(0,0,0,0.04);
}

.category-inner{
  max-width: 520px;
  margin: 0 auto;
}

.category-select-wrap{
  position: relative;
  width: 100%;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 18px;
  padding: 6px;
}

.category-trigger{
  width: 100%;
  height: 46px;
  border-radius: 16px;
  border: 1px solid rgba(122, 57, 0, 0.14);
  background: rgba(255, 255, 255, 0.12);
  color: #7a3900;
  font-size: 18px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  box-shadow: 0 10px 22px rgba(0,0,0,0.04);
  cursor: pointer;
  user-select: none;
}

.category-trigger-text{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 360px;
}

.category-trigger-arrow{
  width: 10px;
  height: 10px;
  border-right: 2px solid #7a3900;
  border-bottom: 2px solid #7a3900;
  transform: rotate(45deg);
  margin-right: 2px;
  transition: transform 0.18s ease;
}

.category-trigger-arrow.is-open{
  transform: rotate(-135deg);
  margin-top: 6px;
}

.category-dropdown{
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  width: 100%;
  background: rgba(255, 247, 237, 0.98);
  border-radius: 16px;
  border: 1px solid rgba(122, 57, 0, 0.12);
  box-shadow: 0 18px 45px rgba(0,0,0,0.10);
  overflow: hidden;
  z-index: 60;
  max-height: 280px;
  overflow-y: auto;
}

.category-option{
  padding: 12px 14px;
  font-size: 17px;
  color: #7a3900;
  cursor: pointer;
  background: transparent;
  transition: background 0.12s ease;
}

.category-option:hover{
  background: rgba(134, 90, 48, 0.12);
}

.category-option.is-active{
  background: rgba(134, 90, 48, 0.18);
  font-weight: 800;
}

.book {
  padding: 16px; /* 页面整体左右留白 */
}

.book-list {
  display: grid;
  grid-template-columns: repeat(3, 5fr); /* 两列 */
  gap: 20px; /* 行列间距 */
  margin-top: 20px;
}

.book-item {
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s;
}

.book-item:hover {
  transform: scale(1.05);
}

.book-img {
  width: 100%;
  border-radius: 30px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
      border: 2px solid #130000;
}

.book-name {
  margin-top: 8px;
  font-size: 23px;
  font-weight: bold;
  color: #865a30;
}

.home-content {
  height: calc(100vh - 200px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.load-more-tip {
  text-align: center;
  padding: 20px 0;
}

.loading-text, .load-end-text {
  font-size: 24px;
  color: #865a30;
}

</style>



// WEBPACK FOOTER //
// src/page/Book.vue